// Ported from LC2 (src/commons/components/HomeTabs/Esg/FinancialUnlocks.js +
// FinancialUnlockBox.js, merged into one file since the box was only ever used here). Same
// fields per row (title, value, optional display_tooltip/tooltip_text). Visual layer now
// matches the actual Figma frame (node 18158:8619 "Section → Form") instead of the earlier
// guess: a bordered "table" of flex cells (label + value, tooltip in the corner) rather
// than colored pill boxes — same cell pattern StatCards.js already uses for its row of
// stats. The FontAwesome question-mark tooltip icon is swapped for
// @mui/icons-material's HelpOutlineIcon (already an LC-new dependency). The PDF-export
// button LC2 rendered alongside the title is dropped here (see EsgComponent.js, which now
// renders it once above all three blocks, matching the Figma "Page Header").
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Stack, Tooltip, Typography} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import {tokens} from '../../../themes/ThemeCustomization';

const FinancialUnlockBox = ({data}) => {
    const title = data.title ?? '';
    const value = data.value ?? '';
    const displayTooltip = data.display_tooltip ?? false;
    const tooltipText = data.tooltip_text ?? '';

    return (
        <Box
            sx={{
                flex: '1 1 0',
                minWidth: '166px',
                position: 'relative',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                rowGap: 0.5,
                backgroundColor: tokens.color.white,
                borderRight: `1px solid ${tokens.color.neutral200}`,
                borderBottom: `1px solid ${tokens.color.neutral200}`
            }}
        >
            {displayTooltip && tooltipText && (
                <Tooltip
                    arrow
                    title={
                        <Stack rowGap={0.5} sx={{p: 0.5}}>
                            {tooltipText.split('. ').map((str, idx) => (
                                <Typography key={idx} variant="caption">
                                    {str}
                                </Typography>
                            ))}
                        </Stack>
                    }
                >
                    <HelpOutlineIcon fontSize="small" sx={{position: 'absolute', top: 12, right: 11, color: tokens.color.neutral500}} />
                </Tooltip>
            )}
            <Typography variant="body2" color="text.secondary">
                {title}
            </Typography>
            <Typography variant="h6" fontWeight={600}>
                {value}
            </Typography>
        </Box>
    );
};

FinancialUnlockBox.propTypes = {
    data: PropTypes.object
};

const FinancialUnlocks = ({data}) => {
    const title = data.title ?? '';
    const description = data.description ?? '';
    const rows = data.rows ?? [];

    return (
        <Box sx={{border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', backgroundColor: tokens.color.white, p: 2}}>
            <Stack rowGap={0.5} sx={{pb: 2}}>
                <Typography variant="h5" fontWeight={600}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </Stack>
            <Box sx={{display: 'flex', border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', overflow: 'hidden'}}>
                {rows.map((row, index) => (
                    <FinancialUnlockBox key={`${row.title}-${index}`} data={row} />
                ))}
            </Box>
        </Box>
    );
};

FinancialUnlocks.propTypes = {
    data: PropTypes.object
};

export default FinancialUnlocks;
